export function removeDimensionSortPrefix(textLabel: string): string {
  const idx = textLabel.indexOf("|")
  if (idx >= 0) {
    return textLabel.slice(Math.max(0, idx + 1))
  }

  return textLabel
}
